import React from "react";
import { Colors } from "../../Constants/colors";

interface Props {
  lists: {
    key: string;
    value: string | number;
    listStyle?: React.CSSProperties;
  }[];
}

export const KeyValueList = ({ lists }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {/* <GridWrapper totalColumns={2} /> */}
      {lists.map(({ key, value, listStyle = {} }) => (
        <div key={key}>
          <div
            className="flex flex-row gap-2"
            style={{
              color: Colors.DarkGrey,
              ...listStyle,
            }}
          >
            <div>{key}:</div>
            <div className="flex-1 text-left">{value}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
